import React, { useCallback, useEffect, useState, useRef } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import "../Assets/WebsiteCss/Header.css";

import slide1 from "../Assets/images/carousel/carouselone.jpeg";
import slide2 from "../Assets/images/carousel/carouseltwo.jpeg";
import slide3 from "../Assets/images/carousel/carouselthree.png";
import modelImage from "../Assets/images/carousel/modelImage.png";

const slides = [
  {
    image: slide1,
    title: "Innovative Solutions for Every Project",
    subtitle: "Delivering Quality. On Time. Every Time.",
    description:
      "From concept to completion, RK Constructions ensures the highest standards in civil engineering and construction.",
  },
  {
    image: slide2,
    title: "Building Homes That Define Comfort",
    subtitle: "Residential & Commercial Construction Experts",
    description:
      "We create modern, durable spaces designed to last for generations.",
  },
  {
    image: slide3,
    title: "Engineering Excellence You Can Trust",
    subtitle: "15+ Years of Industry Experience",
    description:
      "Precision planning, superior materials, and professional execution.",
  },
];

export default function HeaderCarousel() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const autoplayRef = useRef(
    Autoplay({ delay: 5000, stopOnInteraction: false }),
  );

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    autoplayRef.current,
  ]);

  const scrollTo = useCallback(
    (index) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi],
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi, onSelect]);

  // Removed handleMouseEnter and handleMouseLeave

  return (
    <section className="hero-carousel">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((slide, index) => (
            <div className="embla__slide" key={index}>
              <div
                className="hero-slide"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="hero-overlay" />

                <div className="hero-content">
                  <div className="hero-text">
                    <span className="hero-strip" />
                    <h1>{slide.title}</h1>
                    <h2>{slide.subtitle}</h2>
                    <p>{slide.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fixed Model Image - Outside the slides */}
      <div className="hero-model-fixed">
        <img src={modelImage} alt="Happy Family Home" />
      </div>

      {/* Navigation Dots */}
      <div className="embla-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`embla-dot ${index === selectedIndex ? "active" : ""}`}
            onClick={() => scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
